// @flow

type XBKBushingTypes = {
  [string]: {
    [string]: string
  }
};

const xbkBushingTypes: XBKBushingTypes = {
  'VOR XBK2': {
    '1 5/16"': 'MTO',
    '1 3/8"': 'MTO',
    '1 7/16"': 'STOCK',
    '1 1/2"': 'MTO',
    '1 5/8"': 'MTO',
    '1 11/16"': 'MTO',
    '1 3/4"': 'MTO',
    '1 7/8"': 'STOCK',
    '1 15/16"': 'STOCK'
  },

  'VOR XBK3': {
    '1 11/16"': 'MTO',
    '1 3/4"': 'MTO',
    '1 7/8"': 'MTO',
    '1 15/16"': 'STOCK',
    '2"': 'STOCK',
    '2 3/16"': 'STOCK'
  },

  'VOR XBK4': {
    '1 15/16"': 'STOCK',
    '2"': 'STOCK',
    '2 1/8"': 'MTO',
    '2 3/16"': 'STOCK',
    '2 1/4"': 'MTO',
    '2 7/16"': 'STOCK'
  },

  'VOR XBK5': {
    '2 3/16"': 'STOCK',
    '2 1/4"': 'MTO',
    '2 7/16"': 'STOCK',
    '2 1/2"': 'MTO',
    '2 11/16"': 'MTO',
    '2 15/16"': 'STOCK'
  },

  'VOR XBK6': {
    '2 7/16"': 'STOCK',
    '2 1/2"': 'MTO',
    '2 11/16"': 'MTO',
    '2 7/8"': 'MTO',
    '2 15/16"': 'STOCK',
    '3"': 'MTO',
    '3 7/16"': 'STOCK'
  },

  'VOR XBK7': {
    '2 15/16"': 'MTO',
    '3"': 'MTO',
    '3 3/16"': 'MTO',
    '3 7/16"': 'STOCK',
    '3 15/16"': 'STOCK'
  },

  'VOR XBK8': {
    '2 15/16"': 'MTO',
    '3 7/16"': 'STOCK',
    '3 15/16"': 'STOCK',
    '4 3/16"': 'MTO',
    '4 7/16"': 'STOCK'
  },

  'VOR XBK9': {
    '3 7/16"': 'MTO',
    '3 15/16"': 'STOCK',
    '4 7/16"': 'STOCK',
    '4 15/16"': 'STOCK'
  }
};

export default xbkBushingTypes;



// WEBPACK FOOTER //
// ./src/utils/vortex/xbk-bushing-types.js